/**
 * Feature flags read from build-time env. Centralised so call sites
 * import the resolved boolean. Read `process.env.GATSBY_*` with plain
 * member access — Gatsby inlines that at build time, but a `typeof process`
 * guard or optional chaining (`?.`) breaks the inlining and reads false
 * in the browser.
 */

/**
 * Allow racing legs and sport legs to coexist in a single multi.
 * Off by default — racing × sport is treated as a related-events
 * conflict by `areRelated`.
 */
export const ALLOW_CROSS_PRODUCT_MULTI =
  process.env.GATSBY_ENABLE_CROSS_PRODUCT_MULTI === "true";
